import React from 'react';
import { Grid, Typography, Avatar, Link, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HelpIcon from '@mui/icons-material/Help';
import Time from '../Shared/Time';
import { useTheme } from '@mui/material/styles';


const ExecutionBlock = props => {
    const theme = useTheme();
    const href = `/executions/${props.item?.StateMachine}:${props.item?.ExecutionID}`
    const status = {
        Succeeded: {
            icon: <CheckCircleIcon />,
            color: theme.palette.success.main
        },
        Failed: {
            icon: <CancelIcon />,
            color: theme.palette.error.main
        },
        Aborted: {
            icon: <HelpIcon />,
            color: theme.palette.neutral.main
        }
    }

    return (
        <Grid container className="ExecutionBlock">
            <Grid item xs={2} className="ExecutionBlockTime">
                <Time start={props.item.StartTime} date={props.date} />
            </Grid>
            <Grid item xs={9}>
                <Grid container>
                    <Grid item xs={12} className="ExecutionBlockDuration">
                        <Box
                            onClick={() => props.href && window.open(href, '_blank', 'noopener,noreferrer')}
                            sx={{
                                width: (props.item.Duration / props.maxWidth),
                                background: status[props.item.Status].color,
                                ml: (props.item.Buffer * 100) + '%',
                            }}
                        />
                        <Avatar sx={{ color: status[props.item.Status].color }}>
                            {status[props.item.Status].icon || <HelpIcon />}
                        </Avatar>
                        <Typography color={status[props.item.Status].color}>
                            {new Date(props.item.Duration * 1000).toISOString().slice(14, 19)}
                        </Typography>
                    </Grid>
                    {props.item?.error &&
                        <Grid>
                            <Typography sx={{ color: theme.palette.error.main,}}>{props.item?.error}</Typography>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </Grid>
    )
}
export default React.memo(ExecutionBlock);